import { useState, useEffect } from 'react';
import { extractLengthAndSize, generateUniqueLengthOptions, generateUniqueSizeOptions, getActiveSizeOptions, getOptionIndex, splitSizesBySizeAndLength, } from '../util/ProductUtil';
export const useSelectedSizes = (options, filteredSizes, selectedColorId, selectedSku, selectSize) => {
    const [selectedSizeOption, setSelectedSizeOption] = useState('');
    const [selectedLengthOption, setSelectedLengthOption] = useState('');
    const [sizeOptions, setSizeOptions] = useState([]);
    const [lengthOptions, setLengthOptions] = useState([]);
    const { isSizeAndLengthSplitted, sizesMap, lengthsMap } = splitSizesBySizeAndLength(filteredSizes);
    useEffect(() => {
        if (!isSizeAndLengthSplitted)
            return;
        if (selectedSizeOption && selectedLengthOption) {
            const sizeIndex = getOptionIndex(options, selectedSizeOption, selectedLengthOption);
            if (sizeIndex === -1) {
                selectSize({ sku: null });
            }
        }
    }, [isSizeAndLengthSplitted, selectedLengthOption]);
    useEffect(() => {
        if (!isSizeAndLengthSplitted)
            return;
        if (selectedSizeOption && selectedLengthOption) {
            const sizeIndex = getOptionIndex(options, selectedSizeOption, selectedLengthOption);
            if (sizeIndex === -1) {
                selectSize({ sku: null });
            }
        }
    }, [isSizeAndLengthSplitted, selectedSizeOption]);
    useEffect(() => {
        if (!isSizeAndLengthSplitted)
            return;
        if (selectedSizeOption && selectedLengthOption) {
            const sizeIndex = getOptionIndex(options, selectedSizeOption, selectedLengthOption);
            if (sizeIndex !== -1 && options[sizeIndex]) {
                const { size, length } = extractLengthAndSize(options[sizeIndex].label.toString());
                selectSize({ sku: options[sizeIndex].value.toString(), isSoldOut: options[sizeIndex].isSoldOut });
                setLengthOptions(getActiveSizeOptions(sizesMap.get(size), options, lengthOptions, 'length'));
                setSizeOptions(getActiveSizeOptions(lengthsMap.get(length), options, sizeOptions, 'size'));
            }
            else {
                selectSize({ sku: null, isDisabled: true });
            }
        }
    }, [isSizeAndLengthSplitted, selectedSizeOption, selectedLengthOption]);
    useEffect(() => {
        var _a, _b;
        if (!isSizeAndLengthSplitted)
            return;
        if (selectedSku) {
            const size = ((_a = [...sizesMap.entries()].find(([, value]) => value.includes(selectedSku))) === null || _a === void 0 ? void 0 : _a[0]) || null;
            const length = ((_b = [...lengthsMap.entries()].find(([, value]) => value.includes(selectedSku))) === null || _b === void 0 ? void 0 : _b[0]) || null;
            if (size && length) {
                setSelectedSizeOption(size);
                setSelectedLengthOption(length);
            }
        }
    }, [isSizeAndLengthSplitted, selectedSku]);
    useEffect(() => {
        if (!isSizeAndLengthSplitted)
            return;
        if (!selectedSku) {
            setSelectedLengthOption('');
            setSelectedSizeOption('');
        }
        const sOptions = generateUniqueSizeOptions(options);
        const lOptions = generateUniqueLengthOptions(options, lengthsMap);
        const enabledLengthOptions = lOptions.filter(option => !option.disabled && !option.isSoldOut);
        const enabledSizeOptions = sOptions.filter(option => !option.disabled && !option.isSoldOut);
        if (lOptions.length === 1 && enabledLengthOptions.length === 1 && enabledLengthOptions[0]) {
            setSelectedLengthOption(enabledLengthOptions[0].label.toString());
            setSizeOptions(getActiveSizeOptions(lengthsMap.get(enabledLengthOptions[0].label), options, sOptions, 'size'));
        }
        else {
            setSizeOptions(sOptions);
        }
        if (sOptions.length === 1 && enabledSizeOptions.length === 1 && enabledSizeOptions[0]) {
            setSelectedSizeOption(enabledSizeOptions[0].label.toString());
            setLengthOptions(getActiveSizeOptions(sizesMap.get(enabledSizeOptions[0].label.toString()), options, lOptions, 'length'));
        }
        else {
            setLengthOptions(lOptions);
        }
    }, [isSizeAndLengthSplitted, selectedColorId]);
    return {
        sizeOptions,
        setSizeOptions,
        selectedSizeOption,
        setSelectedSizeOption,
        lengthOptions,
        setLengthOptions,
        selectedLengthOption,
        setSelectedLengthOption,
    };
};
